import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { class: "loading-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_svg_icon, {
        class: "rotate-infinite",
        type: "mdi",
        path: _ctx.mdiReload
      }, null, 8, ["path"])
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _createElementVNode("table", {
      class: _normalizeClass(["table", _ctx.tableClasses])
    }, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.columnsConfig, (columnConfig) => {
            return (_openBlock(), _createElementBlock("th", {
              key: columnConfig.title,
              class: _normalizeClass(columnConfig.columnClasses)
            }, _toDisplayString(columnConfig.title), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: element[_ctx.elementsKey],
            class: _normalizeClass(this.rowClassesFn(element))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsConfig, (columnConfig, colIndex) => {
              return (_openBlock(), _createElementBlock("td", {
                key: `${index}-${colIndex}`
              }, [
                (_ctx.isPropertyColumnConfig(columnConfig))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(columnConfig.dataClasses)
                    }, _toDisplayString(element[columnConfig.propertyName]), 3))
                  : _createCommentVNode("", true),
                (_ctx.isSlotColumnConfig(columnConfig))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(columnConfig.dataClasses)
                    }, [
                      _renderSlot(_ctx.$slots, columnConfig.slotName, {
                        row: element,
                        data: _ctx.elements,
                        index: index,
                        columnConfig: columnConfig
                      })
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 2))
        }), 128))
      ])
    ], 2)
  ]))
}